import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfCtaText, sfCtaUrl, sfHeadline, sfImage, sfSub } from './sectionHelpers';

interface Props {
  section: SectionInstance;
}

const HeroSplit: React.FC<Props> = ({ section }) => {
  const c = section.controls;
  const stats = (c.stats || []) as Array<{ number: string; label: string }>;

  return (
    <header className="sb-render sb-render-hero-split" style={{ padding: '120px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>
        <div>
          {c.badge_text && (
            <span style={{
              display: 'inline-block', background: 'rgba(37,99,235,0.1)',
              color: 'var(--brand-primary, #2563eb)', padding: '6px 16px',
              borderRadius: 9999, fontSize: '0.875rem', fontWeight: 600, marginBottom: 16,
            }}>
              {c.badge_text}
            </span>
          )}
          <InlineEditText
            tag="h1"
            controlKey="headline"
            style={{ fontSize: '3.75rem', lineHeight: 1.1, marginBottom: 16, letterSpacing: '-0.025em', fontWeight: 800 }}
          >
            {sfHeadline(c, 'Your Headline Here')}
          </InlineEditText>
          <InlineEditText
            tag="p"
            controlKey="subheadline"
            style={{ fontSize: '1.125rem', color: 'var(--brand-text-light, #64748b)', marginBottom: 32 }}
          >
            {sfSub(c, 'Supporting subheadline text goes here')}
          </InlineEditText>
          {sfCtaText(c) !== undefined || true ? (
            <a href={sfCtaUrl(c)} className="sb-cta-btn" style={{
              display: 'inline-block', padding: '14px 32px', borderRadius: 'var(--brand-btn-radius, 6px)',
              background: 'var(--brand-primary, #1a365d)', color: '#fff', fontWeight: 600, textDecoration: 'none',
              boxShadow: '0 4px 14px rgba(0,0,0,0.15)', transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}>
              <InlineEditText tag="span" controlKey="cta_text">
                {sfCtaText(c, 'Get Started')}
              </InlineEditText>
            </a>
          ) : null}
          {c.show_stats && stats.length > 0 && (
            <div style={{ display: 'flex', gap: 32, marginTop: 32 }}>
              {stats.slice(0, 4).map((s, i) => (
                <div key={i} style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '2.5rem', fontWeight: 700, color: 'var(--brand-primary, #2563eb)' }}>{s.number}</div>
                  <div style={{ fontSize: '0.875rem', color: 'var(--brand-text-light, #64748b)' }}>{s.label}</div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          {sfImage(c) ? (
            <img src={sfImage(c)} alt={c.image_alt || 'Hero'} style={{ width: '100%', borderRadius: 'var(--brand-card-radius, 12px)', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.08), 0 8px 10px -6px rgba(0,0,0,0.04)' }} />
          ) : (
            <div style={{ background: '#f1f5f9', borderRadius: 'var(--brand-card-radius, 12px)', aspectRatio: '4/3', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
              Image placeholder
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default HeroSplit;
